import React from 'react';

const style = {
  wrap: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 10,
  },
}

export default ({title, src, height}) => {
  return (
    <div style={style.wrap}>
      <img alt="Cover" style={{height}} src={src} />
      <br />
      {title}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/TitledImage.js